import React from "react";
import "./ValuationToolkit.css";

const ValuationToolkit = () => {
  const toolkitItems = [
    {
      id: 1,
      title: "Vivamus Eget Lorem a Dui",
      date: "September 10, 2020",
      linkText: "Download Brochure",
    },
    {
      id: 2,
      title: "Vivamus Eget Lorem a Dui",
      date: "September 10, 2020",
      linkText: "Download Case Study",
    },
    {
      id: 3,
      title: "Vivamus Eget Lorem a Dui",
      date: "September 10, 2020",
      linkText: "Download Whitepaper",
    },
  ];

  return (
    <div className="valuation-toolkit">
      <h2>The Knowledge Hub</h2>
      <h1>Your Valuation Toolkit:</h1>
      {/* <h1>Free Valuation Toolkit:</h1>
      <h3>Templates & Financial Models</h3>
      <p>
        Download our Business Valuation Checklist and Financial Projection
        Template.
      </p>*/}
      <h3>Knowledge Made Simple</h3>
      <p>
        Discover how we've hepled businesses simplify valuation, make better
        decision, and unlock growth opportunities.
      </p>
      <div className="toolkit-cards">
        {toolkitItems.map((item) => (
          <div className="card" key={item.id}>
            <div className="card-content">
              <h3>{item.title}</h3>
              <p className="date">{item.date}</p>
              <a href="#" className="link">
                {item.linkText}
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ValuationToolkit;
